import { createFileRoute } from "@tanstack/react-router";
import {
  isTachographKind,
  TachographKind,
} from "../../../../api/tachograph.types";
import UserTachographProgress from "../../../../features/User/UserTachographProgress/UserTachographProgress";

export const Route = createFileRoute("/(app)/users/$id/tachograph")({
  component: RouteComponent,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    kind: TachographKind;
  } => ({
    kind: isTachographKind(search.kind) ? search.kind : "manual-entry",
  }),
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { kind } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <UserTachographProgress
      userId={Number(id)}
      selectedKind={kind}
      onSelectKind={(kind) =>
        navigate({ search: { kind }, replace: true, resetScroll: false })
      }
    />
  );
}
